import angular from 'angular';
import { ApontamentosImportacaoService } from '../apontamentosimportacao.service';
import { ApontamentosImportacaoModalService } from '../modal.importar/apontamentosimportacao.importarmodal.service';
import { ApontamentosResultadoModalService } from '../modal.resultado/apontamentosimportacao.resultadomodal.service';
import { ModalConfirmService } from '../../../shared/components/modal-confirm/modal.confirm.service';
import { IApontamentoImportacao, IApontamentoImportacaoArquivo } from '../models/apontamentosimportacao.model';
import { OperacaoApontamentosImportacaoEnum } from '../enums/operacao';
import { ResultadoApontamentosImportacaoEnum } from '../enums/resultado';
import { applyNsjTableInlineMobileLabels, buildNsjTableInlineMobileLabel } from '../../../utils/nsj-table';

export class ApontamentosImportacaoIndexController {

    static $inject = [
        '$scope',
        '$rootScope',
        '$state',
        '$filter',
        'NewToaster',
        'ApontamentosImportacaoService',
        'ApontamentosImportacaoModalService',
        'ApontamentosResultadoModalService',
        'ModalConfirmService'
    ];

    public busy: boolean = false;
    public entities: Array<IApontamentoImportacao>;
	public carregouParte: boolean = false;

    public fields = applyNsjTableInlineMobileLabels([
		{
			value: 'created_at',
			label: 'Data da importação',
			type: 'date',
			style: 'title',
			copy: '',
            customCollumnHtml: () => {
                let someHtmlVar = `
				<span ng-bind="tableRowEntity.created_at | asDateTime | date: 'dd/MM/yyyy hh:mm:ss'">
                `;
                return someHtmlVar;
            },
		},
        {
			value: 'competenciaFormatada',
			label: 'Competência',
			type: 'string',
			style: 'title',
			copy: '',
		},
		{
			value: 'nomearquivooriginal',
			label: 'Nome do arquivo',
			type: 'string',
			style: 'title',
			copy: '',
		},
/*		{
			value: 'estabelecimento',
			label: 'Estabelecimento',
			type: 'string',
			style: 'title',
			copy: '',
            customCollumnHtml: () => {
                let someHtmlVar = `
                <span ng-bind="tableRowEntity.estabelecimento.nomefantasia">
                `;
                return someHtmlVar;
            },
		},*/
		{
			value: 'status',
			label: 'Situação',
			type: 'string',
			style: 'title',
			copy: '',
            customCollumnScope: {
                setLabelSituacao: (status: string) => {
                    const situacao = status.trim().toLowerCase();
                    const situacaoToLabel = {
                        'aguardando': 'label-aberta',
                        'processando': 'label-aberta',
                        'processado': 'label-primary',
                        'processado com erros': 'label-primary',
                        'arquivo vazio': 'label-primary',
                        'erro no processamento': 'label-primary',
                        'excluído': 'label-danger',
                        'excluído parcialmente': 'label-danger',
                    };
                    return situacaoToLabel[situacao] ?? '';
                },
                setTextoSituacao: (status: string) => {
                    const situacao = status.trim().toLowerCase();
                    const situacaoToText = {
                        'aguardando': 'PROCESSANDO',
                        'processando': 'PROCESSANDO',
                        'processado': 'PROCESSADO',
                        'processado com erros': 'PROCESSADO',
                        'arquivo vazio': 'PROCESSADO',
                        'erro no processamento': 'PROCESSADO',
                        'excluído': 'EXCLUÍDO',
                        'excluído parcialmente': 'EXCLUÍDO PARCIALMENTE',
                    };
                    return situacaoToText[situacao] ?? status;
                },
                resultadoEnum: ResultadoApontamentosImportacaoEnum
            },
            customCollumnHtml: () => {
                let someHtmlVar = `
                    <label
                        class="label {{customCollumnScope.setLabelSituacao(tableRowEntity.status)}}"
                        ng-bind-template="{{customCollumnScope.setTextoSituacao(tableRowEntity.status)}}"
                    ></label>
                `;
                return someHtmlVar;
            },
		},
        {
			value: 'resultado',
			label: 'Resultado',
			type: 'string',
			style: 'title',
			copy: '',
            customCollumnScope: {
                abrirModalResultado: (entity: IApontamentoImportacao): void => {
                    this.ApontamentosResultadoModalService.open(entity).result.catch(() => {/**/});
                },
                setLabelResultado: (resultado: ResultadoApontamentosImportacaoEnum) => {
                    const resultadoToLabel = {
                        [ResultadoApontamentosImportacaoEnum.SUCESSO]: 'label-success',
                        [ResultadoApontamentosImportacaoEnum.ERRO]: 'label-danger',
                        [ResultadoApontamentosImportacaoEnum.PARCIAL]: 'label-warning',
                    };
                    return resultadoToLabel[resultado] ?? '';
                },
                setTextoResultado: (resultado: ResultadoApontamentosImportacaoEnum) => {
                    const resultadoToText = {
                        [ResultadoApontamentosImportacaoEnum.SUCESSO]: 'IMPORTADO COM SUCESSO',
                        [ResultadoApontamentosImportacaoEnum.ERRO]: 'ARQUIVO INVÁLIDO',
                        [ResultadoApontamentosImportacaoEnum.PARCIAL]: 'IMPORTADO PARCIALMENTE',
                    };
                    return resultadoToText[resultado] ?? '';
                },
                temDetalhesResultado: (resultado: ResultadoApontamentosImportacaoEnum) => {
                    return resultado === ResultadoApontamentosImportacaoEnum.PARCIAL ||
                        resultado === ResultadoApontamentosImportacaoEnum.ERRO;
                }
            },
            customCollumnHtml: () => {
                let someHtmlVar = `
                    <label
                        ng-click="customCollumnScope.temDetalhesResultado(tableRowEntity.resultado)
                            && customCollumnScope.abrirModalResultado(tableRowEntity)"
                        ng-class="{
                            'cursor-pointer': customCollumnScope.temDetalhesResultado(tableRowEntity.resultado)
                        }"
                        class="label {{customCollumnScope.setLabelResultado(tableRowEntity.resultado)}}"
                        ng-bind-template="{{customCollumnScope.setTextoResultado(tableRowEntity.resultado)}}"
                    ></label>
                `;
                return someHtmlVar;
            },
		},
        {
            value: 'importacaoapontamento',
            label: 'Ações',
            type: 'div',
            style: 'title',
            copy: '',
            customLabelHtml: buildNsjTableInlineMobileLabel('Ações', { showOnMobile: false }),
            customCollumnScope: {
                downloadArquivo: (importacaoapontamento: string, nomearquivooriginal: string) => {
                    this.downloadImportacao(importacaoapontamento, nomearquivooriginal);
                },
                desfazerImportacao: (importacaoapontamento: string) => {
                    this.abrirModalDesfazerImportacao(importacaoapontamento);
                },
                resultadoEnum: ResultadoApontamentosImportacaoEnum,
            },
            customCollumnHtml: () => {
                let someHtmlVar = `
                    <div class="display-flex justify-content-center justify-content-end-md">
                        <nsj-button-dropdown
                            border="none"
                            split="false"
                            size="sm"
                            icon="fas fa-ellipsis-v"
                            dropdown-direction="right"
                            class="menuEllipsis"
                            ng-if="tableRowEntity.resultado === customCollumnScope.resultadoEnum.SUCESSO
                                || tableRowEntity.resultado === customCollumnScope.resultadoEnum.PARCIAL"
                        >
                            <item-dropdown
                                item-label="Download"
                                ng-click="customCollumnScope.downloadArquivo(tableRowEntity.importacaoapontamento, tableRowEntity.nomearquivooriginal)"
                            ></item-dropdown>
                            <item-dropdown
                                item-label="Desfazer importação"
                                ng-click="customCollumnScope.desfazerImportacao(tableRowEntity.importacaoapontamento)"
                            ></item-dropdown>
                        </nsj-button-dropdown>
                        <a
                            class="btn btn-tertiary btn-sm"
                            ng-click="customCollumnScope.downloadArquivo(tableRowEntity.importacaoapontamento, tableRowEntity.nomearquivooriginal)"
                            ng-if="!(tableRowEntity.resultado === customCollumnScope.resultadoEnum.SUCESSO
                                || tableRowEntity.resultado === customCollumnScope.resultadoEnum.PARCIAL)"
                        >
                            Download
                        </a>
                    </div>
                `;
                return someHtmlVar;
            },
        }
	]);

    constructor (
		public $scope: angular.IScope,
        public $rootScope: angular.IRootScopeService & { nsjGlobals: any },
		public $state: angular.ui.IStateService,
        public $filter: angular.IFilterFunction,
        public NewToaster: { pop: Function },
        public ApontamentosImportacaoService: ApontamentosImportacaoService,
        public ApontamentosImportacaoModalService: ApontamentosImportacaoModalService,
        public ApontamentosResultadoModalService: ApontamentosResultadoModalService,
        public ModalConfirmService: ModalConfirmService,
	) {
        // enquanto nao ha o paginacao no back, so sao carregadas as ultimas importacoes atraves da loadData()
        this.loadData();
        // this.ApontamentosImportacaoService.reload();
        $scope.$on('meurh_importacoesapontamentos_loaded', (event: any, args: any) => {
            this.entities = [... args];
            this.formataEntities();
            this.busy = false;
			this.carregouParte = true;
        });

        this.onSubmitSuccess();
        this.onSubmitError();
        this.onDeleteSuccess();
        this.onDeleteError();
    }

    abrirModalImportar(): void {
        const fileDefault = {
            file: {} as FileList,
            operation: OperacaoApontamentosImportacaoEnum.SOMAR,
            competencia: {}
        };

        const modal = this.ApontamentosImportacaoModalService.open(fileDefault);
        modal.result.then((response: IApontamentoImportacaoArquivo) => {
            this.busy = true;

            const formData = new FormData();
            formData.append('estabelecimento', this.$rootScope.nsjGlobals.a.estabelecimento);
            formData.append('planilha', response.file[0]);
            formData.append('operacao', response.operation.toString());
            formData.append('mesreferencia', response.competencia.mes.toString());
            formData.append('anoreferencia', response.competencia.ano.toString());

            this.ApontamentosImportacaoService.save(formData);
        }).catch(() => {/**/});
    }

    abrirModalDesfazerImportacao(importacaoapontamento: string): void {
        const customText = {
            title: 'Desfazer importação',
            subtitle: 'Você está prestes desfazer a importação dos movimentos.',
            confirmText: 'Essa ação não poderá ser revertida. Tem certeza de que deseja continuar?',
            closeButton: 'Voltar',
            confirmButton: 'Desfazer importação',
        };
        const confirm = this.ModalConfirmService.openCancelar(null, 'Importação de movimentos', customText);
        confirm.result.then(() => {
            this.busy = true;
            this.ApontamentosImportacaoService.delete(importacaoapontamento);
        }).catch(() => {/**/});
    }

    downloadImportacao(importacaoapontamento: string, nomeArquivo: string) {
        this.busy = true;
        this.ApontamentosImportacaoService.download(importacaoapontamento)
        .then(result => {
            this.handleDownload(result, nomeArquivo);
            this.NewToaster.pop({
                type: 'success',
                title: 'Download realizado com sucesso!',
            });
        }).finally(() => this.busy = false);
    }

    handleDownload(file: File, fileName: string) {
        const blob = new Blob([file], {
            type: 'application/octet-stream'
        });

        const fileURL = URL.createObjectURL(blob);
        const a = document.createElement('a');

        document.body.appendChild(a);
        a.style.display = 'none';
        a.href = fileURL;
        a.download = fileName ?? 'arquivo.bin';
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(fileURL);
    }

    formataEntities(): void {
        const statusToResultado = {
            'aguardando': ResultadoApontamentosImportacaoEnum.PROCESSANDO,
            'processando': ResultadoApontamentosImportacaoEnum.PROCESSANDO,
            'processado': ResultadoApontamentosImportacaoEnum.SUCESSO,
            'processado com erros': ResultadoApontamentosImportacaoEnum.PARCIAL,
            'excluído': ResultadoApontamentosImportacaoEnum.EXCLUIDO,
            'excluído parcialmente': ResultadoApontamentosImportacaoEnum.EXCLUIDO_PARCIALMENTE,
            'arquivo vazio': ResultadoApontamentosImportacaoEnum.ERRO,
            'erro no processamento': ResultadoApontamentosImportacaoEnum.ERRO
        };

        this.entities.forEach((entity: IApontamentoImportacao) => {
            entity.status = entity.status.trim().toLowerCase();

            if (entity.log) {
                try {
                    entity.logObj = JSON.parse(entity.log);
                } catch {
                    console.error('Log inválido:', entity);
                }
            }

            entity.resultado = statusToResultado[entity.status] ?? ResultadoApontamentosImportacaoEnum.PROCESSANDO;
            this.formataCompetencia(entity);
        });
    }

    formataCompetencia(entity: IApontamentoImportacao) {
        if (entity.mesreferencia && entity.anoreferencia) {
            entity['competenciaFormatada'] = `${this.$filter('mesEnum')(entity.mesreferencia)}/${entity.anoreferencia}`;
            return;
        }
        entity['competenciaFormatada'] = 'Não informado';
    }

    loadData(): void {
        let quantidadePaginas = 1;
        this.ApontamentosImportacaoService.reload(quantidadePaginas);
    }

    loadMore(): void {
		this.ApontamentosImportacaoService.loadMore();
	}

    onSubmitSuccess(): void {
        this.$scope.$on('meurh_importacoesapontamentos_submitted', (event: angular.IAngularEvent, args: any): void => {
            this.NewToaster.pop({
                type: 'success',
                title: 'A planilha foi enviada com sucesso!'
            });
            this.$state.reload();
        });
    }

    onSubmitError(): void {
        this.$scope.$on('meurh_importacoesapontamentos_submit_error', (event: angular.IAngularEvent, args: any): void => {
            this.busy = false;
            if (args.response.data && typeof (args.response.data.message) !== 'undefined' && args.response.data.message) {
                if (args.response.data.message === 'Validation Failed') {
                    let message = args.response.data.errors.errors[0];

                    this.NewToaster.pop({
                        type: 'error',
                        title: 'Erro de Validação',
                        body: message,
                        bodyOutputType: 'trustedHtml'
                    });
                } else {
                    this.NewToaster.pop({
                        type: 'error',
                        title: args.response.data.message
                    });
                }
            } else {
                this.NewToaster.pop({
                    type: 'error',
                    title: 'Ocorreu um erro ao enviar a planilha!'
                });
            }
        });
    }

    onDeleteSuccess(): void {
        this.$scope.$on('meurh_importacoesapontamentos_deleted', (event, args) => {
            this.NewToaster.pop({
                type: 'success',
                title: 'A importação foi excluída com sucesso!'
            });
            this.$state.reload();
        });
    }

    onDeleteError(): void {
        this.$scope.$on('meurh_importacoesapontamentos_delete_error', (event, args) => {
            this.busy = false;
            const message = args.data?.message as string ?? '';
            this.NewToaster.pop({
                type: 'error',
                title: 'Ocorreu um erro ao excluir a importação!',
                body: message
            });
        });
    }
}
